import { Controller } from "@hotwired/stimulus"

// Validates that a signature has been inserted before form submission
// when the requirement is mandatory.
export default class extends Controller {
  static targets = ["signatureInput", "signatureBox"]

  connect() {
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.form = this.element.closest("form")
    this.form?.addEventListener("submit", this.handleFormSubmit)
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.handleFormSubmit)
  }

  handleFormSubmit(event) {
    if (!this.hasSignatureInputTarget) return

    const value = this.signatureInputTarget.value?.trim()
    if (value) return

    event.preventDefault()
    event.stopImmediatePropagation()

    if (this.hasSignatureBoxTarget) {
      this.signatureBoxTarget.scrollIntoView({ behavior: "smooth", block: "center" })
      this.signatureBoxTarget.classList.add("signature-box--error")
      setTimeout(() => {
        this.signatureBoxTarget.classList.remove("signature-box--error")
      }, 2000)
    }
  }
}
